<template>
  <el-button
    link
    type="primary"
    @click="onDialogVisibleFn"
  >
    {{ proxy.$t('expor.export') }}
  </el-button>
  <!-- <el-dialog v-model="dialogVisible" title="选择导出内容" width="600" :append-to-body="true">

  </el-dialog> -->
  <el-drawer
    v-model="dialogVisible"
    :append-to-body="true"
    :with-header="false"
    size="38%"
  >
    <div class="title">
      {{ proxy.$t('expor.export') }} <el-icon
        class="icon"
        @click="dialogVisible = false"
      >
        <Close />
      </el-icon>
    </div>
    <div class="expottlist">
      <el-form-item
        :label="proxy.$t('expor.exportName')"
        required
      >
        <el-input
          v-model="inputName"
          style="max-width: 600px"
          :placeholder="proxy.$t('Shared.pleaseEnter')"
        >
          <template #append>
            .xlsx
          </template>
        </el-input>
        <div class="exportNameTip">
          {{ proxy.$t('expor.exportNameTip') }}
        </div>
      </el-form-item>
      <div class="taber">
        <div class="headerBox">
          <div class="header_l">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="isCheckList.length > 0 && !checkAll"
              @change="handleCheckAllChange"
            >
              {{ proxy.$t('excel.chetip') }}<span style="color: #777">({{ chnckList.length }})</span>
            </el-checkbox>
          </div>
          <div class="header_r">
            <div>
              {{ proxy.$t('excel.ischeTip') }}<span style="color: #777">({{ isCheckList.length }})</span>
            </div>
            <div
              class="del"
              @click="delChange"
            >
              {{ proxy.$t('Shared.Clear') }}
            </div>
          </div>
        </div>
        <div class="exporCenterBox">
          <div class="exporCenter_R">
            <div
              v-for="(item, i) in chnckList"
              :key="item.key || i"
              class="che_item"
              @click.self="onCheckFn(i)"
            >
              <el-checkbox
                v-model="item.checked"
                :label="item.title"
                size="large"
                @click.stop
              />
            </div>
          </div>
          <div class="exporCenter_L">
            <sortList
              v-model:list="isCheckList"
              @del="itemDel"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <div />
      <div>
        <el-button @click="dialogVisible = false">
          {{ proxy.$t('Shared.Cancel') }}
        </el-button>
        <el-button
          :disabled="!isCheckList.length > 0 || !inputName"
          type="primary"
          :loading="submitting"
          @click="submitForm()"
        >
          {{ proxy.$t('expor.export') }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script setup lang="ts">
import { getCurrentInstance, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getInputValidationError, normalizeSearchParams } from '@/utils/form/inputRules';
import { Close } from '@element-plus/icons-vue';
import { exporExcelApi } from '../../api/export/index.ts';
import SortList from './sortList.vue';
const { proxy } = getCurrentInstance();
const props = defineProps({
  api: {
    type: String,
    default: '',
  },
  fileName: {
    type: String,
    default: '',
  },
  pageParams: {
    type: Object,
    default: () => ({}),
  },
  columns: {
    type: Array,
    default: () => [],
  },
});
const checkAll = ref(false);
const submitting = ref(false);
const t = (key: string, params?: Record<string, string | number>) => proxy.$t(key, params);

// 请求数据
const dialogVisible = ref(false);
const chnckList = ref([]);
const isCheckList = ref([]);
const Params = ref({});
const inputName = ref('');
const onCheckFn = (i) => {
  chnckList.value[i].checked = !chnckList.value[i].checked;
};
watch(
  () => chnckList.value, // 监听的源：props 中的 search
  (data) => {
    isCheckList.value = data.filter((v) => {
      return v.checked;
    });
    if (data.length == isCheckList.value.length) {
      checkAll.value = true;
    } else {
      checkAll.value = false;
    }
  },
  { deep: true, immediate: true },
);
const submitForm = async () => {
  if (submitting.value) return;
  if (!isCheckList.value.length) return ElMessage.warning(t('expor.exporttip'));
  const payload = normalizeSubmitData(JSON.parse(JSON.stringify(Params.value)), { fileName: 'naturalText' });
  payload.fileName = normalizeSubmitData({ fileName: inputName.value }, { fileName: 'naturalText' }).fileName;
  const error = getInputValidationError(t, payload.fileName, { strategy: 'naturalText', kind: 'fileName', required: true, label: 'expor.exportName' });
  if (error) return ElMessage.warning(error);
  payload.headList = isCheckList.value.map(item => ({ ...item }));
  submitting.value = true;
  try {
    const res = await exporExcelApi(props.api, payload);
    if (res.code === 200) {
      ElMessage.success(`${payload.fileName}.xlsx${t('expor.exportSuccess')}`);
      dialogVisible.value = false;
    }
  } catch {
    // 请求失败保留导出名称和勾选结果。
  } finally {
    submitting.value = false;
  }
};
const itemDel = (item) => {
  chnckList.value.forEach((v) => {
    if (v.key == item.key) {
      v.checked = !v.checked;
    }
  });
};
const handleCheckAllChange = () => {
  if (checkAll.value) {
    // 全选
    chnckList.value.forEach((v) => {
      v.checked = true;
    });
  } else {
    chnckList.value.forEach((v) => {
      v.checked = false;
    });
  }
};
const delChange = () => {
  checkAll.value = false;
  handleCheckAllChange();
};
const onDialogVisibleFn = () => {
  dialogVisible.value = true;
  Params.value = normalizeSearchParams(JSON.parse(JSON.stringify(props.pageParams)), ['nickName']);
  inputName.value = props.fileName;
  chnckList.value = JSON.parse(
    JSON.stringify(
      props.columns
        .filter((v) => {
          return v.prop != 'action';
        })
        .map((s) => {
          return { title: s.label, key: s.prop, checked: false };
        }),
    ),
  );
};
</script>
<style lang="scss" scoped>
.title {
  height: 30px;
  border-bottom: 1px #eeeeee solid;
  font-weight: 600;
  position: relative;
  .icon {
    position: absolute;
    inset-inline-end: 10px;
    font-size: 20px;
  }
}
.expottlist {
  overflow-y: auto;
  padding: 10px 0;
  .exportNameTip {
    font-size: 14px;
    color: #c2bfbf;
  }
  .taber {
    text-align: auto;
    .headerBox {
      display: flex;
      background: #f2f3f5;
      height: 40px;
      color: #333;
      line-height: 40px;

      .header_l {
        width: 50%;
        padding: 0 10px;
        flex: 1;
        display: flex;
        justify-content: space-between;
        position: relative;
        top: 5px;
      }
      .header_r {
        padding: 0 10px;
        flex: 1;
        font-size: 14px;
        display: flex;
        color: #606266;
        justify-content: space-between;
        .del {
          color: var(--color-1);
          cursor: pointer;
        }
      }
    }
    .exporCenterBox {
      display: flex;
      text-align: start;
      border: 1px solid #eeeeee;
      .exporCenter_R {
        height: calc(100vh - 260px);
        border-inline-end: 1px solid #eeeeee;
        width: 50%;
        padding: 0 10px;
        overflow-y: auto;
        .che_item {
          border-bottom: 1px solid #f1efef;
        }
      }
      .exporCenter_L {
        width: 50%;
        height: calc(100vh - 260px);
        padding: 0 10px;
        overflow-y: auto;
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: space-between;
  border-top: 1px #eeeeee solid;
  padding-top: 10px;
}
</style>
